class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('submit', this.onProductShortcutSubmit.bind(this));
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  normalizeSearchTerm(value) {
    return value
      .toLocaleLowerCase('es')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  searchTokenMatches(token, keyword) {
    if (token === keyword) return true;
    if (token.length < 5 || keyword.length < 5 || Math.abs(token.length - keyword.length) > 1) return false;

    let previous = Array.from({ length: keyword.length + 1 }, (_, index) => index);

    for (let tokenIndex = 1; tokenIndex <= token.length; tokenIndex += 1) {
      const current = [tokenIndex];

      for (let keywordIndex = 1; keywordIndex <= keyword.length; keywordIndex += 1) {
        const substitutionCost = token[tokenIndex - 1] === keyword[keywordIndex - 1] ? 0 : 1;
        current[keywordIndex] = Math.min(
          current[keywordIndex - 1] + 1,
          previous[keywordIndex] + 1,
          previous[keywordIndex - 1] + substitutionCost
        );
      }

      previous = current;
    }

    return previous[keyword.length] <= 1;
  }

  getProductShortcut(value) {
    const normalizedTerm = this.normalizeSearchTerm(value);
    if (!normalizedTerm) return null;

    const tokens = normalizedTerm.split(' ');
    const hasKeyword = (keywords) =>
      tokens.some((token) => keywords.some((keyword) => this.searchTokenMatches(token, keyword)));

    const productMatches = [
      {
        url: '/products/packs',
        keywords: ['jengibre', 'ginger', 'digestion', 'digestivo', 'digestiva'],
      },
      {
        url: '/products/packs-shots-de-curcuma',
        keywords: ['curcuma', 'curcumina', 'pimienta', 'pina', 'inflamacion', 'recuperacion'],
      },
      {
        url: '/products/packs-shot-vitajuz-de-matcha',
        keywords: ['matcha', 'miel', 'energia', 'enfoque', 'concentracion', 'cafe'],
      },
    ].filter((product) => hasKeyword(product.keywords));

    if (productMatches.length === 1) return productMatches[0].url;
    if (productMatches.length > 1) return '/products/pack-de-3';

    const ritualKeywords = [
      'shot',
      'shots',
      'vitajuz',
      'pack',
      'packs',
      'ritual',
      'sabores',
      'surtido',
      'manzana',
      'limon',
    ];

    return hasKeyword(ritualKeywords) ? '/products/pack-de-3' : null;
  }

  onProductShortcutSubmit(event) {
    if (event.defaultPrevented || this.querySelector('[aria-selected="true"] a')) return;

    const shortcut = this.getProductShortcut(this.input.value);
    if (!shortcut) return;

    event.preventDefault();
    window.location.assign(shortcut);
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
